import styled from 'styled-components/macro';
import { Icon as UnstyledIcon } from './icon';

export const Icon = styled(UnstyledIcon)`
    fill: currentColor;    
`;